import { createReducer } from 'pobble-components/dist/redux-helpers'

let defaultState = {
  search: ''
}

const SchoolsFilter = createReducer(defaultState, {
  'SCHOOL_FILTER:SET_SEARCH_VALUE': (state, { searchValue }) => ({
    ...state,
    search: searchValue
  }),
  'SCHOOLS:SEARCHING_REQUEST': (state, { params }) => ({
    ...state,
    search: params.searchValue
  })
})

export default SchoolsFilter
